import React from 'react';
import './Preview.css';
import { services } from '../List/list.json';
import { Link } from 'react-router-dom';

class OfferPreview extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0)
  }

  render() {
    let subtitle, steps;
    let selectedElement = services[Math.floor(this.props.match.params.id)]

    if (selectedElement.subtitle) {
      subtitle = <h3>{services[Math.floor(this.props.match.params.id)].subtitle}</h3>
    }

    if (selectedElement.steps.length) {
      steps = (
        <ul>
          {selectedElement.steps.map(step => <li>{step}</li>)}
        </ul>
      )
    }

    return (
      <div className="container preview-container">
        <Link to="/#offer" className="preview-btn">powrót</Link>
        <div className="preview-heading">
          <h1>{selectedElement.title}</h1>
          {subtitle}
        </div>
        <div className="preview-time-price">
          <ul>
            {selectedElement.time.map((t, i) => {
              return <li>{t} {selectedElement.price[i]} </li>
            })}
          </ul>
        </div>
        {selectedElement.desc.map(p => <p className="preview-p">{p}</p>)}
        {steps}
      </div>
    )
  }
}

export default OfferPreview;
